import { PartitionCard } from '@/components'
import { StyledPartitionGrid } from '@/components/styles'
import genLinkParams from '@/lib/generateLinkParams'

export default function PartitionGrid(props) {
  const { directions } = props
  return (
    <StyledPartitionGrid>
      {directions.map((direction) => {
        const {
          id,
          title: directionTitle,
          slug: directionSlug,
          preview,
          preview_mobile,
        } = direction

        const [href, as] = [`/services?direction=${directionSlug}`, `/services?direction=${directionSlug}`]

        return (
          <StyledPartitionGrid.Item key={`service-${id}`}>
            <PartitionCard
              image={preview}
              imageT={preview_mobile}
              title={directionTitle}
              link={{ href, as }}
            />
          </StyledPartitionGrid.Item>
        )
      })}
    </StyledPartitionGrid>
  )
}
